export default __webpack_public_path__ + "static/media/meeting4.c05e5838.svg";